<button
  [vw]
  class="btn"
  [primary]="primary"
  [large]="large"
  [small]="small"
  [light]="light"
  [type]="type"
  (click)="click()"
  [disabled]="disabled"
  [rounded]="rounded"
  [border]="border"
  [icon]="icon"
>
  {{ text }}
</button>
